import { gql } from '@apollo/client'

export const GETUSERPROFILE = gql`
  query GetUserProfile {
    getUserProfile {
      isActive
      emailId
      userRole
      signOutAt
      members {
        role
      }
      client {
        clientBusinessType
      }
    }
  }
`

export const SENDFORGOTPASSWORDMAIL = gql`
  mutation sendForgotPasswordMail($emailId: String!, $role: UserRoles!) {
    sendForgotPasswordMail(emailId: $emailId, role: $role)
  }
`

export const RESETPASSWORD = gql`
  mutation resetPassword($token: String!, $newPassword: String!) {
    resetPassword(token: $token, newPassword: $newPassword)
  }
`
export const VERIFYRESETPASSWORD = gql`
  query VerifyResetPasswordToken($token: String!) {
    verifyResetPasswordToken(token: $token)
  }
`
export const GETTPVADMINCLIENTSLIST = gql`
  query GetTpvAdminClientsListBySearch($searchClientListInput: SearchClientListInput!) {
    getTpvAdminClientsListBySearch(searchClientListInput: $searchClientListInput) {
      clients {
        name
        id
        logoUrl
        noOfBrands
        updatedAt
        isActive
        city
        country
        zipCode
      }
      totalCount
    }
  }
`
export const GETDASHBOARDMETRICS = gql`
  query getTpvAdminDashboardMetrics($filter: TpvAdminClientTpvListFilterInput) {
    getTpvAdminDashboardMetrics (filter: $filter) {
      totalClients
      totalAgents
      totalTpv
    }
  }
`

export const GETCLIENTDETAILS = gql`
  query GetAllClients {
    getAllClients {
      id
      name
    }
  }
`

export const GET_TPV_ADMIN_CLIENT_TPV_LIST = gql`
  query GetTpvAdminClientTpvList($filter: TpvAdminClientTpvListFilterInput) {
    getTpvAdminClientTpvList(filter: $filter) {
      name
      noOfAgents
      totalTexts
      totalLiveAgentSeconds
      totalIVRSeconds
      textTpvs
      imageUploadsCount
      contractSends
      totalEnrollments
      totalTpvs
      clientId
      city
      country
      zipCode
    }
  }
`
export const GETSIGNEDURLFORUPLOAD = gql`
  query getSignedUrlForUpload($bucketName: String!, $key: String!) {
    getSignedUrlForUpload(bucketName: $bucketName, key: $key) {
      preSignedUrl
    }
  }
`

export const SEARCHCLIENT = gql`
  query getTpvAdminClientsListBySearch($searchClientListInput: SearchClientListInput!) {
    getTpvAdminClientsListBySearch(searchClientListInput: $searchClientListInput) {
      clients {
        id
        name
      }
      totalCount
    }
  }
`

export const CREATECLIENT = gql`
  mutation createClient($createClientInput: CreateClientInput!) {
    createClient(createClientInput: $createClientInput) {
      id
      name
      address
      zipCode
      state
      logoUrl
      city
      clientNotes {
        id
        position
        description
      }
      clientAdmin {
        emailId
      }
      updatedAt
      brands {
        id
        name
        brandAdmin {
          emailId
        }
      }
      clientDialInNumbers {
        id
        dialInNumber
        position
      }
      isGoogleSearchAheadRequired
      isTranscribedResponseRequired
      isBillImagesRequired
    }
  }
`
export const REMOVECLIENT = gql`
  mutation removeClient($id: String!) {
    removeClient(id: $id)
  }
`

export const GETCLIENTBYID = gql`
  query GetTpvAdminClientById($id: String!) {
    getTpvAdminClientById(id: $id) {
      name
      id
      enableCustomerDetails
      clientNotes {
        clientId
        description
        position
        id
      }
      clientDialInNumbers {
        id
        dialInNumber
        position
      }
      clientLiveAgentNumber {
        liveAgentDialInNumber
        id
        vendorCallForwardingNumber
        isOutBound
        languageId
        language {
          id
          languageName
        }
        vendorId
      }
      clientAdmin {
        id
        emailId
      }
      brands {
        name
        id
        brandAdmin {
          id
          emailId
        }
      }
      state
      address
      logoUrl
      city
      address
      country
      creditType
      creditAmount
      lateChargeFees
      clientDunsNumber
      isEdiRecordingSyncRequired
      isEdiEnrollmentRequired
      isCopyUan
      monthlyFees
      monthlyMinimums
      salesTax
      setupFees
      stripeFees
      perTpv
      perMin
      notes
      zipCode
      enableLiveAgent
      enableSmsDocumentVerification
      enableEmailDocumentVerification
      enableNoTPV
      enableLineTypeIntelligence
      enableEmailService
      enableOutBoundLiveAgent
      enableApiCheck
      enableDynamicProductCreation
      enableContractStartDate
      isUtilityMeterNumberRequired
      billUploadOnlyByCamera
      disableExistingCustomerEnrollment
      enableZipCodeInUtility
      enableCustomerReportToSalesChannel
      isGoogleSearchAheadRequired
      isTranscribedResponseRequired
      isBillImagesRequired
      enableTextTpv
      clientOptInMessage
      clientOutBoundMessage
      enableContractRequired
      enableTelephoneViewForSalesAdmin
      enableMultipleUan
      enableKaptureCrm
      isSmartDocEnabled
    }
  }
`
export const UPDATECLIENT = gql`
  mutation updateClient($updateClientInput: UpdateClientInput!) {
    updateClient(updateClientInput: $updateClientInput) {
      id
      name
      updatedAt
      clientNotes {
        clientId
        description
        position
        id
      }
      isGoogleSearchAheadRequired
      isTranscribedResponseRequired
      isBillImagesRequired
      brands {
        id
        name
      }
    }
  }
`

export const GET_SIGNED_URL_FOR_DOWNLOAD = gql`
  query GetSignedUrlForDownload($key: String!, $bucketName: String!) {
    getSignedUrlForDownload(key: $key, bucketName: $bucketName) {
      preSignedUrl
    }
  }
`

export const VALIDATE_USER = gql`
  query validateUser($validateUserInput: ValidateUserInput!) {
    validateUser(validateUserInput: $validateUserInput) {
      users {
        emailId
        id
        message
        type
      }
    }
  }
`
// Admin Account Activation
export const SEND_EMAIL_FOR_ACCOUNT_ACTIVATION = gql`
  mutation sendVerficationCodeMail($emailId: String!, $password: String!, $role: UserRoles!) {
    sendVerficationCodeMail(emailId: $emailId, password: $password, role: $role)
  }
`

// Admin Verification
export const VERIFY_USER = gql`
  mutation verifyUser($emailId: String!, $verificationCode: String!, $role: UserRoles!) {
    verifyUser(emailId: $emailId, verificationCode: $verificationCode, role: $role)
  }
`

export const RE_SEND_VERIFICATION_CODE = gql`
  mutation reSendVerficationCodeMail($emailId: String!, $role: UserRoles!) {
    reSendVerficationCodeMail(emailId: $emailId, role: $role)
  }
`

// Agent-Customer Enrollment
export const CREATE_CUSTOMER_ENROLLMENT = gql`
  mutation createCustomerEnrollment(
    $createCustomerEnrollmentInput: CreateCustomerEnrollmentInput!
  ) {
    createCustomerEnrollment(createCustomerEnrollmentInput: $createCustomerEnrollmentInput) {
      customerFirstName
      customerLastName
      customerId
      tpvId
      customerPhoneNumber
      transferPhoneNumber
      pincode
    }
  }
`

// Agent-Customer Edit
export const UPDATE_CUSTOMER_ENROLLMENT = gql`
  mutation UpdateCustomerEnrollment(
    $updateCustomerEnrollmentInput: UpdateCustomerEnrollmentInput!
  ) {
    updateCustomerEnrollment(updateCustomerEnrollmentInput: $updateCustomerEnrollmentInput) {
      tpvId
      customerId
      customerFirstName
      customerLastName
      customerPhoneNumber
      transferPhoneNumber
      pincode
    }
  }
`

// Agent- Customer Enrollment Details
export const GET_CUSTOMER_ENROLLMENT_DATA = gql`
  query getCustomerEnrollmentData {
    getCustomerEnrollmentData {
      brands {
        id
        name
      }
      commodities {
        id
        name
      }
      customerTypes {
        id
        name
      }
      contractTypes {
        id
        name
      }
      unitTypes {
        id
        name
      }
      utilities {
        id
        name
      }
    }
  }
`

// PhoneNumber Validation
export const VALIDATE_CUSTOMER_PHONENUMBER = gql`
  query validateCustomerPhoneNumber($phoneNumber: String!) {
    validateCustomerPhoneNumber(phoneNumber: $phoneNumber) {
      type
      message
      phoneNumber
    }
  }
`

export const AGENT_ADMIN_LIST = gql`
  query GetAllCustomersByAgent($customerListInput: CustomerListInput) {
    getAllCustomersByAgent(customerListInput: $customerListInput) {
      totalCount
      isEditable
      customers {
        pincode
        customerId
        firstName
        lastName
        phoneNumber
        customerEnrollments
        productName
        serviceState
        serviceCity
        tpvStatus
        eutilityAccountNumber
        gutilityAccountNumber
        utilityName
        customerUpdatedAt
        tpvType
      }
    }
  }
`
// Get Customer by ID - Agent Admin Edit
export const GET_CUSTOMER_BY_ID = gql`
  query GetCustomerById($id: String!) {
    getCustomerById(id: $id) {
      id
      businessName
      customerType {
        id
        name
      }
      firstName
      lastName
      emailId
      primaryPhoneNumber
      mobileNumber
      serviceAddress1
      serviceAddress2
      serviceCountry
      serviceState
      serviceCity
      serviceZipCode
      serviceUnitType {
        id
        name
      }
      serviceUnitNumber
      billingAddress1
      billingAddress2
      billingCountry
      billingState
      billingCity
      billingZipCode
      billingUnitType {
        id
        name
      }
      billingUnitNumber
      utilityAccountNumber
      documentDelivery
      product {
        id
        name
      }
      languageId
    }
  }
`
export const KEY_PERFORMANCE_METRICS_FILTER = gql`
  query getSalesChannelListByTeamAdminWithFilter($salesChannelListInput: SearchListInput) {
    getSalesChannelListByTeamAdminWithFilter(salesChannelListInput: $salesChannelListInput) {
      salesChannels {
        id
        name
      }
      totalCount
    }
  }
`

export const KEY_PERFORMANCE_METRICS_DATA = gql`
  query GetKpmByTeamAdmin($localTimeZone: String!, $saleChannelsIds: [String!]) {
    getKpmByTeamAdmin(localTimeZone: $localTimeZone, saleChannelsIds: $saleChannelsIds) {
      noOfReports
      kpmData {
        tpvStatusType
        kpiStatus
        tpvToday
        tpvYesterday
        tpvLastWeek
        tpvLastMonth
        tpvLastQuarter
      }
    }
  }
`
//Team Admin product setup
export const GETPRODUCTSETUP = gql`
  query GetProductDetail($productDetailByTypeInput: ProductDetailByTypeInput) {
    getProductDetail(productDetailByTypeInput: $productDetailByTypeInput) {
      names {
        readonly
        value
        type
        id
        utilityDunsNumber
        utilitySubmitDays
        utilityShortName
        utilityName
        utilityPhoneNumber
        uanValidation
        regexValidation
        regexValidationMessage
        meterRegexValidation
        meterRegexValidationMessage
        utilityState
        zipcodes
        notesMetadata
      }
      enum
      type
    }
  }
`
export const ADDPRODUCTSETUP = gql`
  mutation AddProductDetail($addProductDetailInput: AddProductDetailInput!) {
    addProductDetail(addProductDetailInput: $addProductDetailInput)
  }
`

export const GETPRODUCTLIST = gql`
  query GetProductListByTeamAdmin(
    $productListFilterInput: ProductListFilterInput!
    $withDual: Boolean
  ) {
    getProductListByTeamAdmin(
      productListFilterInput: $productListFilterInput
      withDual: $withDual
    ) {
      products {
        adder
        billingMethod
        brand
        commodity
        commodityType
        contractType
        customerType
        deposit
        endDate
        productCode
        billingMethod
        gproductCode
        gadder
        gbillingMethod
        gcontractType
        gdeposit
        grate
        gsecondRate
        gserviceFee
        gterm
        gterminationFee
        gunit
        gutility
        isActive
        prodId
        productCode
        productName
        productNotes
        rate
        scriptId
        scriptName
        secondRate
        serviceFee
        startDate
        term
        terminationFee
        tpvScriptStatus
        unit
        utility
        rateMinimum
        rateMaximum
        termMinimum
        termMaximum
        grateMinimum
        grateMaximum
        gtermMinimum
        gtermMaximum
        state
        solarProduct
        solarFarmName
        dealSourceTier
        availableCustomers
        discountPercentage
        creditCheckRequired
      }
      totalCount
    }
  }
`

// Team Admin Dashboard Data
export const GET_TEAMADMIN_DASHBOARD_DATA = gql`
  query GetTeamAdminDashboard($teamAdminDashboardInput: TeamAdminDashboardInput) {
    getTeamAdminDashboard(teamAdminDashboardInput: $teamAdminDashboardInput) {
      productStatus {
        products {
          productBrand
          productName
          tpvAcceptedCount
        }
        tpvAccepted
      }
      salesPerformance {
        tpvAccepted
        salesChannels {
          salesChannelName
          tpvAcceptedCount
        }
      }
      tpvStatus {
        totalTpvStatus
        tpvStatus {
          qcStatus
          qcStatusCount
        }
      }
      utilityMix {
        tpvAccepted
        utilities {
          tpvAcceptedCount
          utilityName
        }
      }
    }
  }
`

export const GET_PRODUCT_DETAILS = gql`
  query GetProductDetail {
    getProductDetail {
      type
      names {
        id

        value
        readonly
        type
      }
    }
  }
`

// Adding Product
export const CREATE_PRODUCT = gql`
  mutation createProduct($createProductInput: CreateProductInput!) {
    createProduct(createProductInput: $createProductInput) {
      id
      name
    }
  }
`
// Edit Product Details
export const GET_PRODUCT_BY_ID = gql`
 query getProductById($id: String!) {
  getProductById(id: $id) {
    id
    name
    ecode
    brandTypeId
    accountType
    brandType {
      id
      name
      __typename
    }
    commodityId
    commodity {
      id
      name
      __typename
    }
    utilityId
    utility {
      id
      name
      __typename
    }
    contractTypeId
    contractType {
      id
      name
      __typename
    }
    customerTypeId
    customerType {
      id
      name
      __typename
    }
    unitTypeId
    unitType {
      id
      name
      __typename
    }
    unit
    rate
    secondRate
    serviceFee
    term
    earlyTerminationFee
    adder
    deposit
    startDate
    endDate
    notes
    brandId
    clientId
    smartDocProducts {
      id
      documentTypeId
      productId
      languageId
      smartDocId
      position
      language {
        id
        languageName
        __typename
      }
      __typename
    }
    productFiles {
      fileUrl
      id
      position
      languageId
      __typename
    }
    prodScriptId
    script {
      scriptId
      name
      __typename
    }
    isActive
    productNotes {
      id
      description
      position
      __typename
    }
    ebillingMethod
    gutilityId
    gutility {
      id
      name
      __typename
    }
    gunit
    gunitTypeId
    gterm
    gserviceFee
    gsecondRate
    grate
    gearlyTerminationFee
    gdeposit
    gcontractTypeId
    gcode
    gbillingMethod
    gcontractType {
      id
      name
      __typename
    }
    gadder
    productType
    rateMinimum
    rateMaximum
    termMinimum
    termMaximum
    grateMinimum
    grateMaximum
    gtermMinimum
    gtermMaximum
    isDynamicProduct
    __typename
  }
}
`

export const GET_SOLAR_PRODUCT_BY_ID = gql`
  query GetProductById($id: String!) {
    getProductById(id: $id) {
      name
      lmiApproved
      benefitPrograms {
        id
        name
        type
      }

      id
      solarProduct {
        id
        name
      }
      customerType {
        id
        name
      }
      solarFarmName
      ebillingMethod
      discountPercentage
      dealSourceTier {
        id
        name
      }
      productFiles {
        fileUrl
        id
        position
      }
      availableCustomers
      creditCheckRequired
      state
      utility {
        name
        id
      }
      isActive
      script {
        name
        scriptId
      }
    }
  }
`
// Update Product
export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($updateProductInput: UpdateProductInput!) {
    updateProduct(updateProductInput: $updateProductInput)
  }
`
export const CREATE_QC_USER = gql`
  mutation CreateQcUser($createQcUserInput: CreateQcUserInput!) {
    createQcUser(createQcUserInput: $createQcUserInput) {
      id
      firstName
    }
  }
`

export const UPDATE_QC_USER = gql`
  mutation UpdateQcUser($updateQcUserInput: UpdateQcUserInput!) {
    updateQcUser(updateQcUserInput: $updateQcUserInput) {
      salesChannels {
        id
      }
      id
      firstName
    }
  }
`

export const QC_USER_LIST = gql`
  query getQcListByTeamAdmin($qcListInput: QcListInput) {
    getQcListByTeamAdmin(qcListInput: $qcListInput) {
      qcAdmins {
        id
        emailId
        noOfAcceptedTpvs
        noOfPendingTpvs
        noOfSalesChannel
        qcName
        qcSignInTime
        qcSignOutTime
      }
      totalCount
    }
  }
`

export const REMOVE_QC_USER = gql`
  mutation Mutation($qcUserids: [String!]!) {
    deleteQcUser(qcUserids: $qcUserids) {
      emailId
      id
      message
    }
  }
`

export const UPDATE_USER_SIGNIN_SIGNOUT_TIME = gql`
  mutation UpdateUserSignInAndSignOutTime($signIn: Boolean!) {
    updateUserSignInAndSignOutTime(signIn: $signIn)
  }
`
export const GET_USER_BY_ID = gql`
  query GetQcUserById($id: String!) {
    getQcUserById(id: $id) {
      id
      emailId
      firstName
      lastName
      salesChannels {
        id
        name
      }
    }
  }
`

export const GET_ALL_SCRIPTS = gql`
  query GetAllScripts($get: GetScriptsInput!) {
    getAllScripts(get: $get) {
      name
      scriptId
      scriptLanguages {
        language {
          id
          languageName
        }
      }
    }
  }
`
export const GET_ALL_SCRIPTS_LIST = gql`
  query GetAllScripts($getScriptsInput: GetScriptsInput!) {
    getAllScripts(getScriptsInput: $getScriptsInput) {
      scripts {
        commodity
        dialNumber
        dailInNumber
        languageName
        productName
        prompts
        salesChannel
        scriptId
        scriptName
        status
        utility
        gutility
      }
      totalCount
    }
  }
`

export const GET_SALES_CHANNEL_LIST = gql`
  query GetSalesChannelList($salesChannelListInput: SearchListInput!) {
    getSalesChannelList(salesChannelListInput: $salesChannelListInput) {
      salesChannels {
        salesChannelId
        salesChannelRepId
        salesChannelName
        noOfAgents
        noOfProductsAssigned
        salesAdminEmailId
        salesAdminSignInTime
        salesAdminSignOutTime
        isActive
      }
      totalCount
    }
  }
`

// Script Settings
export const GET_SCRIPT_SETTINGS = gql`
  query getScriptSettings {
    getScriptSettings {
      scriptSettingsId
      waitingtime
      retryDays
      questionRetry
      custMaxRetry
      welcomeMessageEN
      welcomeMessageES
      autoApprove
      isMixMatch
    }
  }
`

export const CREATE_SCRIPT_SETTINGS = gql`
  mutation CreateScriptSetting($createScriptSettingInput: CreateScriptSettingInput!) {
    createScriptSetting(createScriptSettingInput: $createScriptSettingInput) {
      scriptSettingsId
    }
  }
`
export const UPDATE_SCRIPT_SETTINGS = gql`
  mutation UpdateScriptSetting($updateScriptSettingInput: UpdateScriptSettingInput!) {
    updateScriptSetting(updateScriptSettingInput: $updateScriptSettingInput) {
      scriptSettingsId
    }
  }
`
export const GETLANGUAGE = gql`
  query GetAllLanguages {
    getAllLanguages {
      id
      languageName
    }
  }
`

export const GET_AGENT_VERIFICATION_LIST = gql`
  query GetAgentVerificationList($agentVerificationListInput: SearchListInput) {
    getAgentVerificationList(agentVerificationListInput: $agentVerificationListInput) {
      agentVerificationList {
        createdAt
        emailId
        id
        agentName
        salesChannelName
        loginUsername
      }
      totalCount
    }
  }
`
export const AGENT_VERIFICATION = gql`
  mutation AgentVerification($agentVerificationInput: AgentVerificationInput!) {
    agentVerification(agentVerificationInput: $agentVerificationInput) {
      id
      emailId
      status
      message
    }
  }
`
export const GET_PRODUCT_BY_FILTER = gql`
  query GetProductByFilter($salesChannelProductInput: SalesChannelProductInput!) {
    getProductByFilter(salesChannelProductInput: $salesChannelProductInput) {
      id
      name
      ecode
      gcode
    }
  }
`

export const CREATE_SALES_CHANNEL = gql`
  mutation CreateSalesChannel($createSalesChannelInput: CreateSalesChannelInput!) {
    createSalesChannel(createSalesChannelInput: $createSalesChannelInput) {
      id
      name
      timeInterval
      agentLeader {
        leaderCode
        leaderId
      }
    }
  }
`

export const CREATESCRIPT = gql`
  mutation CreateScript($createScriptInput: CreateScriptInput!) {
    createScript(createScriptInput: $createScriptInput) {
      scriptId
    }
  }
`

export const UPDATE_SCRIPT = gql`
  mutation Mutation($updateScriptInput: UpdateScriptInput!) {
    updateScript(updateScriptInput: $updateScriptInput) {
      scriptId
    }
  }
`

export const GETSCRIPTBYID = gql`
  query ($getScriptId: String!) {
    getScript(id: $getScriptId) {
      isActive
      tpvType
      name
      scriptDescription
      scriptId
      timeConditionCheck
      voice
      scriptLanguages {
        language {
          id
          languageName
        }
        questions {
          questionType
          id
          position
          description
          continueCall
          scriptType
        }
        id
      }
      products {
        product {
          name
          id
        }
      }
    }
  }
`
export const DELETESCRIPT = gql`
  mutation RemoveScript($scriptId: String!) {
    removeScript(scriptId: $scriptId)
  }
`
export const UPDATESCRIPT = gql`
  mutation UpdateScript($updateScriptInput: UpdateScriptInput!) {
    updateScript(updateScriptInput: $updateScriptInput) {
      languageName
      scriptId
      scriptName
      utility
      status
      salesChannel
      prompts
      productName
      dialNumber
      commodity
    }
  }
`

export const GET_SALES_CHANNEL_BY_ID = gql`
  query GetSalesChannelById($salesChannelId: String!) {
    getSalesChannelById(salesChannelId: $salesChannelId) {
      enableIvr
      enableLiveAgent
      enableNoTPV
      enableTextTpv
      salesChannelId
      salesChannelName
      salesChannelAdminEmail
      salesChannelAdminFirstName
      salesChannelAdminLastName
      enableEmailDocumentVerification
      enableSmsDocumentVerification
      enableOutBoundLiveAgent
      enableContractRequired
      enableTelephoneViewForSalesAdmin
      enableMultipleUan
      salesChannelType
      enableCustomerBillImage
      salesChannelRepId
      products {
        prod_id
        prod_code
        prod_name
      }
      agentLeaders {
        leaderCode
        leaderId
        leaderStatus
        leaderName
      }
    }
  }
`

export const GET_SALES_AGENT = gql`
  query GetSalesChannelAgentsResponse($getSalesChannelAgentsInput: GetSalesChannelAgentsInput!) {
    getSalesChannelAgents(getSalesChannelAgentsInput: $getSalesChannelAgentsInput) {
      totalCount
      agents {
        id
        userId
        entityId
        productCount
        createdAt
        user {
          emailId
          firstName
          lastName
          id
          isDisabled
          repId
          loginUsername
          isActive
        }
      }
    }
  }
`
export const UPDATE_SALES_CHANNEL = gql`
  mutation UpdateSalesChannel($updateSalesChannelInput: UpdateSalesChannelInputs!) {
    UpdateSalesChannel(updateSalesChannelInput: $updateSalesChannelInput)
  }
`

export const GET_SALES_CHANNEL_PRODUCTS = gql`
  query getSalesChannelProducts($salesChannelId: String!) {
    getSalesChannelProducts(salesChannelId: $salesChannelId) {
      id
      commodityId
      commodity {
        id
        name
      }
      utilityId
      utility {
        id
        name
      }
      customerTypeId
      customerType {
        id
        name
      }
      term
      earlyTerminationFee
    }
  }
`

export const CHECK_UPLOAD_STATUS = gql`
  query CheckUploadStatus($trackId: String!) {
    checkUploadStatus(trackId: $trackId) {
      response
      total
      records {
        count
        up_status
      }
    }
  }
`

export const CHECK_UPLOAD_STATUS_FETCH = `
  query CheckUploadStatus($trackId: String!) {
    checkUploadStatus(trackId: $trackId) {
      response
      total
      records {
        count
        up_status
      }
    }
  }
`
export const LOGIN = gql`
query SignInWithUserName($emailId: String!, $password: String!,$recaptchaToken:String!){
    signInWithUserName(userName: $emailId, password: $password,recaptchaToken:$recaptchaToken){
            accessToken
            refreshToken
    }
    
}`

export const UPDATE_USER_BY_EMAIL = gql`
  mutation UpdateUserByEmailId($updateUserByEmailIdInput: UpdateUserByEmailIdInput!) {
    updateUserByEmailId(updateUserByEmailIdInput: $updateUserByEmailIdInput) {
      firstName
    }
  }
`

export const DELETE_USER_AGENT = gql`
  mutation DeleteUser($emailId: String!) {
    deleteUser(emailID: $emailId)
  }
`

export const GET_CUSTOMER_BY_UAN_OR_PHONENUMBER = gql`
  query GetCustomerByUanOrPhone($uanOrPhoneNumber: String) {
    getCustomerByUanOrPhone(uanOrPhoneNumber: $uanOrPhoneNumber) {
      id
      businessName
      customerType {
        id
        name
      }
      firstName
      lastName
      emailId
      primaryPhoneNumber
      mobileNumber
      serviceAddress1
      serviceAddress2
      serviceCountry
      serviceState
      serviceCity
      serviceZipCode
      serviceUnitType {
        id
        name
      }
      serviceUnitNumber
      billingAddress1
      billingAddress2
      billingCountry
      billingState
      billingCity
      billingZipCode
      billingUnitType {
        id
        name
      }
      billingUnitNumber
      documentDelivery
      product {
        id
        name
      }
      languageId
    }
  }
`

export const GET_DO_NOT_ENROLL = gql`
  query GetDneList($dneListInput: SearchListInput!) {
    getDneList(dneListInput: $dneListInput) {
      dnes {
        id
        phoneNumber
        utilityAccountNumber
        zipCode
        reason
        clientId
        brandId
        emailId
      }
      totalCount
    }
  }
`
export const CREATE_DO_NOT_ENROLL = gql`
  mutation CreateDne($createDneInput: CreateDneInput!) {
    createDne(createDneInput: $createDneInput) {
      id
      phoneNumber
      utilityAccountNumber
      zipCode
      reason
      clientId
      brandId
      emailId
    }
  }
`
export const GET_DO_NOT_ENROLL_BY_ID = gql`
  query GetDnebyId($id: String!) {
    getDnebyId(id: $id) {
      id
      phoneNumber
      utilityAccountNumber
      zipCode
      reason
      clientId
      brandId
      emailId
    }
  }
`
export const REMOVE_DO_NOT_ENROLL = gql`
  mutation RemoveDne($id: String!) {
    removeDne(id: $id)
  }
`
export const CREATE_DNES = gql`
  mutation CreateDnes($createDnesInput: [CreateDneInput!]!) {
    createDnes(createDnesInput: $createDnesInput)
  }
`

// Filter - Agent Admin
export const FILTER_PRODUCT = gql`
  query getProductById($id: String!) {
    getProductById(id: $id) {
      id
      name
      brandTypeId
      brandType {
        id
        name
      }
      commodityId
      commodity {
        id
        name
      }
      utilityId
      utility {
        id
        name
      }
      contractTypeId
      contractType {
        id
        name
      }
      unitTypeId
      unitType {
        id
        name
      }
    }
  }
`
// get user role before signin
export const GET_USER_ROLE = gql`
  query GetUserByEmailId($emailId: String!) {
    getUserByEmailId(emailId: $emailId) {
      emailId
      userRole
      memberRole
      isActive
    }
  }
`

// Filter Product

export const GET_PRODUCT_INFO = gql`
  query GetCustomerProductInfo(
    $customerProductInputs: CustomerProductInputs!
    $isMixMatch: Boolean!
  ) {
    getCustomerProductInfo(customerProductInputs: $customerProductInputs, isMixMatch: $isMixMatch) {
      id
      term
      rate
      serviceFee
      gserviceFee
      gcode
      gterm
      grate
      gearlyTerminationFee
      earlyTerminationFee
      gutility {
        uanValidation
        regexValidation
        regexValidationMessage
        meterRegexValidation
        meterRegexValidationMessage
      }
      utility {
        uanValidation
        regexValidation
        regexValidationMessage
        meterRegexValidation
        meterRegexValidationMessage
      }
      commodity {
        id
        name
      }
      ecode
      name
      startDate
      endDate
      isDynamicProduct
      grateMaximum
      grateMinimum
      gtermMaximum
      gtermMinimum
      rateMaximum
      rateMinimum
      termMaximum
      termMinimum
    }
  }
`
export const GET_AGENT_PRODUCTS_AND_FILTER = gql`
  query GetAgentProductsAndFilter($input: AgentProductAndFiltersInput!) {
    getAgentProductsAndFilter(input: $input) {
      products {
        id
        name
        commodity {
          id
          name
        }
        term
        rate
        serviceFee
        gserviceFee
        gcode
        gterm
        grate
        gearlyTerminationFee
        earlyTerminationFee
        gutility {
          uanValidation
          regexValidation
          regexValidationMessage
          meterRegexValidation
          meterRegexValidationMessage
          __typename
        }
        utility {
          uanValidation
          regexValidation
          regexValidationMessage
          meterRegexValidation
          meterRegexValidationMessage
          notesMetadata
          __typename
        }
        ecode
        startDate
        endDate
        isDynamicProduct
        grateMaximum
        grateMinimum
        gtermMaximum
        gtermMinimum
        rateMaximum
        rateMinimum
        termMaximum
        termMinimum
      }
      productFilters {
        brands {
          id
          name
        }
        commodities {
          id
          name
        }
        contractTypes {
          id
          name
        }
        customerTypes {
          id
          name
        }
        utilities {
          id
          name
        }
        solarProducts {
          id
          name
        }
        states {
          name
        }
        billingMethods {
          name
        }
      }
      gasProducts {
        id
        name
        commodity {
          id
          name
        }
        term
        rate
        serviceFee
        gserviceFee
        gcode
        gterm
        grate
        gearlyTerminationFee
        earlyTerminationFee
        gutility {
          uanValidation
          regexValidation
          regexValidationMessage
          meterRegexValidation
          meterRegexValidationMessage
          __typename
        }
        utility {
          uanValidation
          regexValidation
          regexValidationMessage
          meterRegexValidation
          meterRegexValidationMessage
          __typename
        }
        ecode
        startDate
        endDate
        isDynamicProduct
        grateMaximum
        grateMinimum
        gtermMaximum
        gtermMinimum
        rateMaximum
        rateMinimum
        termMaximum
        termMinimum
      }
      gasProductFilters {
        brands {
          id
          name
        }
        commodities {
          id
          name
        }
        contractTypes {
          id
          name
        }
        customerTypes {
          id
          name
        }
        utilities {
          id
          name
        }
        solarProducts {
          id
          name
        }
        states {
          name
        }
        billingMethods {
          name
        }
      }
    }
  }
`
// Product Language
export const GET_PRODUCT_LANAGUAGE_BENEFIT_PROGRAM = gql`
  query GetProductLanguagesAndBenefitPrograms($productId: String!, $tpvId: String) {
    getProductLanguagesAndBenefitPrograms(productId: $productId, tpvId: $tpvId) {
      languageId
      languageName
      benefitPrograms {
        id
        name
        type
      }
    }
  }
`
// Client Active/Inactive
export const UPDATE_CLIENT_STATUS = gql`
  mutation UpdateClientStatus($id: String!, $isActive: Boolean!) {
    updateClientStatus(id: $id, isActive: $isActive)
  }
`
export const GET_CUSTOMER_ENROLLMENT_BY_ID = gql`
  query GetCustomerEnrollmentById($id: String!) {
    getCustomerEnrollmentById(id: $id) {
      id
      businessName
      customerType {
        id
        name
      }
      firstName
      lastName
      emailId
      dateOfBirth
      primaryPhoneNumber
      mobileNumber
      customerBillUrl
      serviceAddress1
      serviceAddress2
      serviceCountry
      serviceState
      serviceCity
      serviceZipCode
      serviceUnitType {
        id
        name
      }
      serviceUnitNumber
      billingAddress1
      billingAddress2
      billingCountry
      billingState
      billingCity
      billingZipCode
      billingUnitType {
        id
        name
      }
      billingUnitNumber
      documentDelivery
      product {
        id
        name
        commodity {
          id
          name
        }
        commodityId
      }
      languageId

      language {
        id
        languageName
      }
      tpvId
      transferPhoneNumber
      pincode
      tpvStatus
      tpvType
      isMixMatch
      gasEnrollment {
        product {
          grateMaximum
          grateMinimum
          gtermMaximum
          gtermMinimum
        }
      }
      electricEnrollment {
        product {
          rateMaximum
          rateMinimum
          termMaximum
          termMinimum
        }
      }
      customerEnrollments {
        id
        utilityAccountNumber
        productType
        productId
        code
        benefitProgramId
        term
        rate
        serviceFee
        enrollmentPosition
        earlyTerminationFee
        isDynamicProductEnrollment
        utilityMeterNumber
        serviceAddress1
        serviceAddress2
        serviceCity
        serviceCountry
        serviceState
        serviceZipCode
        billingAddress1
        billingAddress2
        billingCity
        billingCountry
        billingState
        billingZipCode

        brandType {
          name
          brandId
        }
        contractStartDate
      }
    }
  }
`

//Get product for agent
export const GET_PRODUCT_FOR_AGENT = gql`
  query GetProductsForAgents($agentId: String!) {
    getProductsForAgents(agentId: $agentId) {
      prod_id
      prod_name
    }
  }
`

//update product based on agent
export const UPDATE_PRODUCT_FOR_AGENT = gql`
  mutation Mutation($updateAgentInputs: UpdateAgentInput!) {
    updateAgent(updateAgentInputs: $updateAgentInputs)
  }
`

//Get Qc Dashboard Data
export const GET_QC_DASHBOARD = gql`
  query GetQcDashboard($qcDashboardInput: TpvStatusDashboardInput) {
    getQcDashboard(qcDashboardInput: $qcDashboardInput) {
      tpvReport {
        totalTpvStatus
        tpvStatus {
          qcStatus
          qcStatusCount
        }
      }
      tpvAcceptanceRate {
        totalTpv
        acceptanceRate
        totalAcceptedTpv
      }
    }
  }
`

// Get All Sales Channel by User
export const GET_SALES_CHANNEL_LIST_BY_USER = gql`
  query GetSalesChannelListByUser {
    getSalesChannelListByUser {
      salesChannels {
        id
        name
      }
    }
  }
`

// Get Agents List by Sales Channel Ids
export const GET_AGENTS_BY_SALES_CHANNEL_ID = gql`
  query GetAgentsBySalesChannelIds(
    $agentLeadIds: [String!]
    $agentListInput: SearchListInput
    $salesChannelIds: [String!]
  ) {
    getAgentsBySalesChannelIds(
      agentLeadIds: $agentLeadIds
      agentListInput: $agentListInput
      salesChannelIds: $salesChannelIds
    ) {
      totalCount
      agents {
        agentId
        agentFirstName
        agentLastName
      }
    }
  }
`

export const GET_SALES_CHANNEL_ADMIN_DASHBOARD = gql`
  query GetSalesChannelAdminDashboard($salesChannelAdminDashboardInput: TpvStatusDashboardInput) {
    getSalesChannelAdminDashboard(
      salesChannelAdminDashboardInput: $salesChannelAdminDashboardInput
    ) {
      tpvReports {
        totalTpvs
        tpvStatus {
          tpvStatusType
          tpvStatusCount
        }
      }
      conversionRate {
        conversionRate
        totalTpvs
      }
      customerEnrollment {
        newEnrollment
        totalEnrollment
      }
    }
  }
`

export const GET_TOTAL_TPV_LIST = gql`
  query GetTotalTpvList($totalTpvListInput: TotalTpvListInput) {
    getTotalTpvList(totalTpvListInput: $totalTpvListInput) {
      totalCount
      totalTpvList {
        agentName
        totalTpv
        tpvFailed
        tpvConversionRate
        tpvIncomplete
        tpvPassed
        tpvPending
      }
      totalTpvs
    }
  }
`

export const GET_TPV_RECORDING_LIST = gql`
  query GetAllTpvs($getTpvsInput: GetTpvsInput,$orderBy:Sort) {
    getAllTpvs(getTpvsInput: $getTpvsInput,orderBy:$orderBy) {
      tpvs {
        agentFirstName
        agentLastName
        agentEmailId
        brandName
        city
        commodity
        ediStatus
        contractType
        confirmationNumber
        cusFirstName
        cusLastName
        businessName
        customerType
        disposition
        contractType
        documentDelivery
        primaryPhone
        enrollmentPosition
        productName
        qcStatus
        qcUserName
        salesChannelName
        serviceAddress1
        serviceAddress2
        state
        tpvDate
        tpvId
        tpvStatus
        uan
        productType
        utility
        zipCode
        roundedDuration
        actualDuration
        leadCreatedDate
        tpvType
      }
      totalCount
    }
  }
`
export const GET_AGENTS_BY_SALES_CHANNEL_IDS = gql`
  query GetAgentsBySalesChannelIds(
    $agentLeadIds: [String!]
    $agentListInput: SearchListInput
    $salesChannelIds: [String!]
  ) {
    getAgentsBySalesChannelIds(
      agentLeadIds: $agentLeadIds
      agentListInput: $agentListInput
      salesChannelIds: $salesChannelIds
    ) {
      agents {
        agentFirstName
        agentId
        agentLastName
      }
      totalCount
    }
  }
`
export const GET_SALES_CHANNEL_AGENTS_LIST = gql`
  query GetSalesChannelAgentsList($perPage: Float, $page: Float, $searchText: String!) {
    getSalesChannelAgentsList(PerPage: $perPage, page: $page, searchText: $searchText) {
      totalCount
      agents {
        agentFirstName
        agentLastName
        agentCreatedAt
        agentStatus
        agentProductsCount
        agentName
        agentId
        agentEmail
        agentUserId
        agentRepId
        isDisabled
        loginUsername
        isActive
      }
    }
  }
`
export const GET_CUSTOMER_INFO_BY_TPV_ID = gql`
  query GetCustomerInfoByTpvId($tpvId: String!, $enrollmentPosition:Int!) {
    getCustomerInfoByTpvId(tpvId: $tpvId,enrollmentPosition:$enrollmentPosition) {
      id
      businessName
      customerType {
        id
        name
      }
      firstName
      lastName
      emailId
      gproduct
      billImageUrl
      primaryPhoneNumber
      phoneType
      mobileNumber
      serviceAddress1
      serviceAddress2
      serviceCountry
      serviceState
      serviceCity
      serviceZipCode
      serviceUnitType {
        id
        name
      }
      tpvType
      serviceUnitNumber
      billingAddress1
      billingAddress2
      billingCountry
      billingState
      billingCity
      billingZipCode
      billingUnitType {
        id
        name
      }
      billingUnitNumber
      documentDelivery
      product {
        id
        name
      }
      languageId
      customerEnrollments {
        id
        utilityAccountNumber
        productType
        customerLatitude
        customerLongitude
        contractStartDate
        qcReview
        isCustomerFlaggedByQC
        enrollmentPosition
        notes
        utilityMeterNumber
      }
      agentToCustomerDistance
      agentToServiceBillAddressDistance
    }
  }
`

export const UPDATE_CUSTOMER = gql`
  mutation UpdateCustomer($updateCustomerInput: UpdateCustomerInput!) {
    updateCustomer(updateCustomerInput: $updateCustomerInput) {
      id
    }
  }
`

export const GET_AGENT_INFO_BY_TPV_ID = gql`
  query GetAgentInfoByTpvId($tpvId: String!) {
    getAgentInfoByTpvId(tpvId: $tpvId) {
      agentRepId
      agentEmailId
      agentFirstName
      agentLastName
      agentLeader
      agentLeaderCode
      leadCreatedDate
      salesChannelName
      tpvDate
      agentLatitude
      agentLongitude
      loginUsername
    }
  }
`

export const GET_TPV_RECORDING = gql`
  query GetTpvRecording($tpvId: String!) {
    getTpvRecording(tpvId: $tpvId) {
      disposition
      calls {
        id
        callTime
        callActualDuration
        callRoundedDuration
        recordingSignedUrl {
          preSignedUrl
        }
        answers {
          id
          questionDescription
          description
          recordingStartedAt
          recordingEndAt
          createdAt
        }
      }
      isCustomerFlagged
      qcStatus
      tpvStatus
    }
  }
`

export const UPDATE_TPV = gql`
  mutation UpdateTpv($updateTpv: UpdateTpvInput!) {
    updateTpv(updateTpv: $updateTpv) {
      id
      qcStatus
      disposition
    }
  }
`

export const GET_UNIT_TYPE = gql`
  query GetProductDetail($productDetailByTypeInput: ProductDetailByTypeInput) {
    getProductDetail(productDetailByTypeInput: $productDetailByTypeInput) {
      names {
        readonly
        value
        type
        id
      }
      enum
      type
    }
  }
`
export const UPLOAD_AGENTS = gql`
  mutation UploadAgents(
    $isVerified: Boolean!
    $salesChannelId: String
    $userData: [BulkUserInput!]!
    $trackId: String!
  ) {
    uploadAgents(
      isVerified: $isVerified
      salesChannelId: $salesChannelId
      userData: $userData
      trackId: $trackId
    )
  }
`
export const UPLOAD_AGENTS_USERID_PASSWORD = gql`
  mutation uploadAgentsUserNameFlow(
    $isVerified: Boolean!
    $salesChannelId: String
    $userData: [BulkUserInput!]!
    $trackId: String!
  ) {
    uploadAgentsUserNameFlow(
      isVerified: $isVerified
      salesChannelId: $salesChannelId
      userData: $userData
      trackId: $trackId
    )
  }
`

export const GET_SALESCHANNEL_PRODUCTS = gql`
  query GetSalesChannelProducts {
    getSalesChannelProducts {
      id
      name
    }
  }
`

export const UPDATE_AGENT = gql`
  mutation UpdateAgent($updateAgentInputs: UpdateAgentInput!) {
    updateAgent(updateAgentInputs: $updateAgentInputs)
  }
`

export const GET_AGENT_DASHBOARD = gql`
  query GetAgentDashboard($agentDashboardInput: TpvStatusDashboardInput) {
    getAgentDashboard(agentDashboardInput: $agentDashboardInput) {
      tpvReports {
        totalTpvs
        tpvStatus {
          tpvStatusType
          tpvStatusCount
        }
      }
      conversionRate {
        totalTpvs
        conversionRate
      }
    }
  }
`

export const RESET_PASSWORD = gql`
mutation ResetPasswordWithApp($newPassword:String!,$userName:String!){
    resetPasswordWithApp(newPassword:$newPassword,userName:$userName){
        accessToken
        refreshToken
    }
}
`

export const GET_USER_PROFILE = gql`
  query GetUserProfile($getEntityName: Boolean) {
    getUserProfile(getEntityName: $getEntityName) {
      id
      firstName
      lastName
      emailId
      dateOfBirth
      avatarUrl
      address
      phoneNumber
      userRole
      loginUsername
      members {
        id
        role
        entityType
        entityName
      }
      client {
        clientBusinessType
        name
      }
    }
  }
`
export const UPDATE_USER_PROFILE = gql`
  mutation UpdateUserProfile($updateUserInput: UpdateUserInput!) {
    updateUserProfile(updateUserInput: $updateUserInput) {
      id
      firstName
      lastName
      emailId
      dateOfBirth
      avatarUrl
      address
      phoneNumber
      userRole
      members {
        id
        role
        entityType
        entityName
      }
    }
  }
`

export const SEND_REPORTS_TO_EMAIL = gql`
  query (
    $emailIds: [String!]!
    $reportFilters: ReportFilters!
    $reportFormat: ReportFormat!
    $subject: String!
  ) {
    sendReportsToEmail(
      emailIds: $emailIds
      reportFilters: $reportFilters
      reportFormat: $reportFormat
      subject: $subject
    )
  }
`
export const SEND_ALERTS_TO_EMAIL = gql`
  query SendAlertReportsToEmail(
    $emailIds: [String!]!
    $input: GetAlertReportInput!
    $subject: String!
  ) {
    sendAlertReportsToEmail(emailIds: $emailIds, input: $input, subject: $subject)
  }
`
export const CREATE_REPORT_SETTINGS = gql`
  mutation CreateReportSettings($createReportSettingsInput: CreateReportSettingsInput!) {
    createReportSettings(createReportSettingsInput: $createReportSettingsInput) {
      reportSettingsId
    }
  }
`

export const CREATE_AGENTS = gql`
  mutation CreateAgents($createAgentInputs: [CreateAgentInput!]!, $salesChannelId: String!) {
    createAgents(createAgentInputs: $createAgentInputs, salesChannelId: $salesChannelId)
  }
`
export const CREATE_AGENTS_WITH_USERID_PASSWORD = gql`
  mutation CreateAgentsUserNameFlow($createAgentInputs: [CreateAgentInput!]!, $salesChannelId: String!) {
    createAgentsUserNameFlow(createAgentInputs: $createAgentInputs, salesChannelId: $salesChannelId)
  }
`

export const DELETE_SALES_CHANNELS = gql`
  mutation DeleteSalesChannels($salesChannelIds: [String!]!) {
    deleteSalesChannels(salesChannelIds: $salesChannelIds) {
      id
      message
      name
    }
  }
`
export const DELETE_PRODUCT = gql`
  mutation RemoveProduct($prodId: String!) {
    removeProduct(prodId: $prodId)
  }
`

export const GET_SMART_DOCS_SETUP = gql`
query {
  getSmartDocDetailsByClientId {
    fontAppearance{
    fontSize
    fontStyle
   }
    groupedDetails{
     names{
    id
    value
   }
  type
   enum
  }    


  }
}
`
export const GET_SMART_DOCS_FILTERS = gql`
query  {
  getAllInputValuesAtDocCreation {
  products{
      id
      value
    }
  constructedInputs{
    names{
        id
        value
      }
      type
      enum
  }
  }
}
`
export const CREATE_SMART_DOCS = gql`
mutation CreateOrUpdateSmartDocument($data:UpsertSmartDocumentInput!,$id:String!){
    createOrUpdateSmartDocument(id:$id,data:$data){
smartDocId
    }
}
`
export const CREATE_AND_UPDATE_SMART_DOCS_SETUP = gql`
mutation upsertSmartDocDetails($input: UpsertSmartDocDetailsInput!) {
  upsertSmartDocDetails(input: $input)
}
`
export const GET_ALL_SMART_DOCS_AND_FILTER = gql`
query FetchAll($filter: SmartDocumentsFilterInput) {
  fetchAllSmartDocuments(filter: $filter) {
    total
    page
    limit
    data {
      smartDocId
      documentName
      isActive
      documentTypes {
        smartDocDetailsId
        type
        documentType
      }
      language {
        id
        languageName
      }
      contractType {
        id
        name
      }
      customerType {
        id
        name
      }
      utility {
        id
        name
      }
      commodity {
        id
        name
      }
        stateDetail{
        id
        name
        }
      documentS3Url
      
      additionalInformation
      smartDocProducts {
        product {
          id
          name
        }
      }
    }
  }
}
`



export const DELETE_SMART_DOCS = gql`
mutation DeleteSmartDocumentById($smartDocId:String!){
    deleteSmartDocumentById(smartDocId:$smartDocId)
}
`
export const GET_SMART_DOCS_ID = gql`
query GetSmartDocumentById($id:String!){
    getSmartDocumentById(id:$id){
smartDocId
documentName
isActive
documentTypes{
    smartDocDetailsId
    type

    documentType
}
language{
    languageName
    id
}
contractType{
    id
    name
}
customerType{
    id
    name
}
utility{
    id
    name
}
commodity{
    id
    name
}
stateDetail{
      id
      name
      }
documentS3Url
additionalInformation
eContractDeliveryTime
smartDocProducts{
 product{
    id
    name
 }
}
}
}

`
export const GET_SCHEDULED_REPORTS = gql`
  query GetAllReportSchedules($scheduleReportListInput: ScheduleReportListInput) {
  getAllReportSchedules(scheduleReportListInput: $scheduleReportListInput) {
      scheduleReportList {
      brandId
      calendarDay
      createdById
      reportDay
      reportFilters
      reportFormat
      reportName
      reportFrequency
      reportSettingsId
      reportTime
      reportType
      reportFilters
        user {
        emailId
      }
      createdAt
    }
    totalCount
  }
}
`
export const GET_DIALIN_NUMBERS = gql`
  query getDialInNumbers {
    getDialInNumbers {
    id
    dialInNumber
    position
  }
}
`
export const VALIDATE_DIAL_IN_NUMBERS = gql`
  query ValidateDialInNumbers($numbers: [String!]!) {
  validateDialInNumbers(numbers: $numbers) {
    number
    type
  }
}
`

export const GET_ALL_TAGS = gql`
  query GetAllTags {
    getAllTags {
    tags
  }
}
`
export const DELETE_SCHEDULE_REPORT = gql`
  mutation DeleteReportSchedule($reportSettingsIds: [String!]!) {
  deleteReportSchedule(reportSettingsIds: $reportSettingsIds)
}
`

export const S3_FILE_DELETE = gql`
  query Query($bucketName: String!, $key: String!) {
  s3FileDelete(bucketName: $bucketName, key: $key)
}
`
export const VALIDATE_CUSTOMER_INFO = gql`
  query ValidateCustomer($validateCustomerInput: ValidateCustomerInput!) {
  validateCustomer(validateCustomerInput: $validateCustomerInput) {
    customerValidationType
    isExistingCustomer
    isExistsInDne
    isExistingAgent
  }
}
`

export const GETCLIENTFEATUREFLAGS = gql`
  query GetClientFeatureFlags($customerId: String) {
  getClientFeatureFlags(customerId: $customerId) {
    enableLiveAgent
    enableTextTpv
    enableNoTPV
    enableSmsDocumentVerification
    enableEmailDocumentVerification
    isBillImagesRequired
    isGoogleSearchAheadRequired
    isTranscribedResponseRequired
    enableEmailDocumentVerification
    enableSmsDocumentVerification
    enableOutBoundLiveAgent
    enableApiCheck
    enableTelephoneViewForSalesAdmin
    enableMultipleUan
    name
    id
    enableDynamicProductCreation
    enableContractStartDate
    isUtilityMeterNumberRequired
    enableLineTypeIntelligence
    enableContractRequired
    enableNoTPV
    enableZipCodeInUtility
    enableCustomerReportToSalesChannel
    enableContractRequired
    isSmartDocEnabled
  }
}
`
export const GET_CIPHER_MESSAGE = gql`
  query Query($customerId: String, $primaryPhoneNumber: String, $trackId: String) {
  getCipherMessage(
    customerId: $customerId
      primaryPhoneNumber: $primaryPhoneNumber
      trackId: $trackId
  )
}
`

export const VALIDATE_LINK = gql`
  query ValidateCustomerForUploading($billId: String, $customerId: String, $trackId: String) {
  validateCustomerForUploading(billId: $billId, customerId: $customerId, trackId: $trackId) {
    responseCode
    status
  }
}
`

export const UPLOAD_CUSTOMER_BILLS = gql`
  mutation UploadCustomerBills(
  $billId: String
    $customerId: String
    $trackId: String
    $urls: [String!]
) {
  uploadCustomerBills(billId: $billId, customerId: $customerId, trackId: $trackId, urls: $urls)
}
`

export const TRACK_IMAGE_UPLOADED = `
query TrackImageUploaded($trackId: String!, $toDelete: Boolean) {
  trackImageUploaded(trackId: $trackId, toDelete: $toDelete) {
    billImageUrl
    isDeleted
    status
  }
}
`

export const CREATE_LIVE_AGENT = gql`
  mutation CreateLiveAgent($createLiveAgentInputs: CreateLiveAgentInputs!) {
  createLiveAgent(createLiveAgentInputs: $createLiveAgentInputs)
}
`
export const UPDATE_LIVE_AGENT = gql`
  mutation UpdateLiveAgent($updateLiveAgentInputs: UpdateLiveAgentInputs!) {
  updateLiveAgent(updateLiveAgentInputs: $updateLiveAgentInputs)
}
`

export const GET_ALL_LIVE_AGENTS = gql`
  query GetAllLiveAgents($getAllLiveAgentsInput: GetAllLiveAgentsInput!) {
  getAllLiveAgents(getAllLiveAgentsInput: $getAllLiveAgentsInput) {
      liveAgents {
      id
      liveAgentPhoneNumber
      liveAgentStatus
      liveAgentEmail
      liveAgentName
      vendorName
    }
    totalCount
  }
}
`

export const GET_LIVE_AGENT_BY_ID = gql`
  query GetLiveAgentById($getLiveAgentByIdId: String!) {
  getLiveAgentById(id: $getLiveAgentByIdId) {
    liveAgentEmail
    liveAgentFirstName
    liveAgentLastName
    liveAgentStatus
    id
      vendor {
      id
    }
  }
}
`

export const VERIFY_LIVE_AGENT = gql`
  query VerifyLiveAgentCustomerByPin($pincode: String!) {
  verifyLiveAgentCustomerByPin(pincode: $pincode) {
    clientName
    customerName
    response
    enableCustomerDetails
  }
}
`

export const GET_LIVE_AGENT_QUESTIONS = gql`
  query GetLiveAgentQuestionsByPin($index: Float!, $pincode: String!, $enrollmentPosition: Float!) {
  getLiveAgentQuestionsByPin(index: $index, pincode: $pincode, enrollmentPosition: $enrollmentPosition) {
    questionDescription
    questionId
    questionLanguage
    questionType
    isLastQuestion
    continueCall
  }
}
`

export const SAVE_ANSWER = gql`
  mutation SaveAnswerByPin(
  $answerInput: AnswerInputs!
    $pincode: String!
    $isFlagged: Boolean
    $clientId: String
    $tpvId: String
) {
  saveAnswerByPin(
    answerInput: $answerInput
      pincode: $pincode
      isFlagged: $isFlagged
      clientId: $clientId
      tpvId: $tpvId
  ) {
    isCompleted
    response
    nextEnrollmentPosition
    nextQuestionIndex
  }
}
`

export const GET_CUSTOMER_FEATURE_FLAGS = gql`
  query GetCustomerFeatureFlag {
    getCustomerFeatureFlag {
    enableIvr
    enableTextTpv
    enableLiveAgent
    enableEmailDocumentVerification
    enableSmsDocumentVerification
    enableOutBoundLiveAgent
    isMixMatch
    enableDynamicProductCreation
    enableContractStartDate
    isUtilityMeterNumberRequired
    billUploadOnlyByCamera
    disableExistingCustomerEnrollment
    enableZipCodeInUtility
    enableCustomerReportToSalesChannel
    phoneType
    enableContractRequired
    enableCustomerBillImage
    enableNoTPV
    enableTelephoneViewForSalesAdmin
    enableMultipleUan
  }
}
`

export const GET_CUSTOMER_INFO_BY_PINCODE = gql`
  query GetCustomerInfoByPin($pincode: String!) {
  getCustomerInfoByPin(pincode: $pincode) {
    id
    businessName
      customerType {
      id
      name
    }
    firstName
    lastName
    emailId
    billImageUrl
    tpvType
    tpvId
    primaryPhoneNumber
    mobileNumber
    serviceAddress1
    serviceAddress2
    serviceCountry
    serviceState
    serviceCity
    serviceZipCode
      serviceUnitType {
      id
      name
    }
    serviceUnitNumber
    billingAddress1
    billingAddress2
    billingCountry
    billingState
    billingCity
    billingZipCode
      billingUnitType {
      id
      name
    }
    billingUnitNumber
    documentDelivery
      product {
      id
      name
    }
    languageId
      customerEnrollments {
      id
      utilityAccountNumber
      productType
    }
  }
}
`

export const GET_ALL_VENDORS = gql`
  query GetAllVendors($getAllvendorInputs: GetAllVendorInput!) {
  getAllVendors(getAllvendorInputs: $getAllvendorInputs) {
    totalCount
      vendorList {
      vendorLastName
      vendorFirstName
      vendorEmailId
        vendorNumbers {
        vendorNumber
      }
      id
    }
  }
}
`

export const GET_VENDOR_BY_ID = gql`
  query GetVendorById($getVendorById: String!) {
  getVendorById(id: $getVendorById) {
    vendorFirstName
    vendorLastName
    vendorEmailId
      vendorNumbers {
      vendorNumber
      id
        language {
        id
        languageName
      }
    }
    id
  }
}
`

export const CREATE_VENDOR = gql`
  mutation CreateVendor($createVendorInput: CreateVendorInput!) {
  createVendor(createVendorInput: $createVendorInput)
}
`

export const UPDATE_VENDOR = gql`
  mutation UpdateVendor($updateVendorInput: UpdateVendorInput!) {
  updateVendor(updateVendorInput: $updateVendorInput)
}
`

export const GET_VENDOR_LIST_BY_LANGUAGE = gql`
  query GetVendorListByLanguage($languageId: String!) {
  getVendorListByLanguage(languageId: $languageId) {
    id
    vendorName
  }
}
`
export const GET_CALL_FORWARD_NUMBER_BY_VENDOR = gql`
  query GetVendorForwardingNumberById($getVendorForwardingNumberByIdId: String!, $langid: String!) {
  getVendorForwardingNumberById(id: $getVendorForwardingNumberByIdId, langid: $langid) {
    vendorNumber
  }
}
`

export const GET_SCRIPT_DIALINNUMBERS = gql`
  query GetScriptDialNumbers($tpvType: String!) {
  getScriptDialNumbers(TpvType: $tpvType) {
    dailInNumber
    englishDialInNumberLA
    spanishDialInNumberLA
    tpvType
  }
}
`

export const GET_SCRIPT_DIALNUMBER = gql`
  query GetScriptDialNumberById($scriptId: String!) {
  getScriptDialNumberById(scriptId: $scriptId) {
    dialInNumberIVR
    dialInNumberLiveAgentEng
    dialInNumberLiveAgentSpn
    tpvType
  }
}
`

export const SEND_SMS_TPV = gql`
  mutation SendSmsTpv($tpvId: String!) {
  sendSmsTpv(tpvId: $tpvId)
}
`
export const GET_ALL_QUESTIONS_BY_PINCODE = gql`
  query GetAllQuetionsByPincode($pincode: String!, $clientId: String, $tpvId: String) {
  getAllQuetionsByPincode(pincode: $pincode, clientId: $clientId, tpvId: $tpvId) {
    continueCall
    questionDescription
    questionId
    questionLanguage
    questionType
    enrollmentPosition
  }
}
`
export const SAVE_SMS_ANSWER = gql`
  mutation SaveAnswersByPin(
  $answerInput: [AnswerInputs!]!
    $pincode: String!
    $clientId: String
    $tpvId: String
) {
  saveAnswersByPin(
    answerInput: $answerInput
      pincode: $pincode
      clientId: $clientId
      tpvId: $tpvId
  )
}
`

export const GET_CUSTOMER_INFO_BY_PINCODE_D2D = gql`
  query GetCustomerInfoByPincode($clientId: String!, $pincode: String!, $tpvId: String!, $enrollmentPosition: Int) {
  getCustomerInfoByPincode(clientId: $clientId, pincode: $pincode, tpvId: $tpvId, enrollmentPosition: $enrollmentPosition) {
    brandLogo
    viewBrandInfoOverClient
    id
    firstName
    lastName
    businessName
    emailId
    primaryPhoneNumber
    billingAddress1
    billingCity
    billingCity
    billingCountry
    billingZipCode
    serviceAddress1
    serviceCity
    serviceState
    serviceCountry
    serviceZipCode
      tpvs {
      id
      isMixMatch
      language
        tpvContracts {
        id
        tpvId
        fileUrl
        position
      }
    }
      electricEnrollment {
      id
      tpvId
      productType
      utilityAccountNumber
      code
      term
      rate
      secondRate
      earlyTerminationFee
      serviceFee
      adder
      deposit
        product {
        name
      }
        brandType {
        name
      }
    }
      gasEnrollment {
      id
      tpvId
      productType
      utilityAccountNumber
      code
      term
      rate
      secondRate
      earlyTerminationFee
      serviceFee
      adder
      deposit
        product {
        name
      }
        brandType {
        name
      }
    }
      client {
      name
      clientOptInMessage
      logoUrl
    }
  }
}
`

export const SUBMIT_CONTRACT = gql`
  mutation UpdateContract($updateContractInputs: UpdateContractInputs!) {
  updateContract(updateContractInputs: $updateContractInputs)
}
`
export const GET_TPV_CONTRACT_FILES = gql`
  query GetTpvContractFilesByTpvId($tpvId: String!, $enrollmentPosition: Int!) {
  getTpvContractFilesByTpvId(tpvId: $tpvId, enrollmentPosition: $enrollmentPosition) {
    contractUrl
    shouldGenerateContract
      productFiles {
      fileUrl
      position
      id
    }
  }
}
`
export const SEND_CONTRACT_AFTER_QC_APPROVE = gql`
  mutation SendContractAfterQcApproved($pincode: String!, $clientId: String, $tpvId: String, $enrollmentPosition: Int!) {
  sendContractAfterQcApproved(pincode: $pincode, clientId: $clientId, tpvId: $tpvId, enrollmentPosition: $enrollmentPosition)
}
`
export const GET_CUSTOMER_INFO_BY_PINCODE_DOWNLOAD_FILES = gql`
  query GetCustomerInfoByPincode($pincode: String!) {
  getCustomerInfoByPincode(pincode: $pincode) {
    clientName
    clientLogo
    customerFirstName
    customerLastName
    productName
  }
}
`
export const GET_CUSTOMER_DOCUMENTS = gql`
  query GetCustomerDocuments($pincode: String!, $clientId: String, $tpvId: String) {
  getCustomerDocuments(pincode: $pincode, clientId: $clientId, tpvId: $tpvId) {
    fileUrl
    position
    id
  }
}
`
export const GET_CUSTOMER_INFO_PDF = gql`
  query Query($tpvId: String!) {
  getCustomerInfoAsPDF(tpvId: $tpvId)
}
`

export const CHECK_PHONE_NUMBER_OPTIN = gql`
  query Query($phoneNumber: String!) {
  checkPhoneNumberOptinStatus(phoneNumber: $phoneNumber) {
    dialInNumber
    optinStatus
  }
}
`

export const GET_CIPHER_EMAIL = gql`
  query Query($customerId: String, $emailId: String, $trackId: String) {
  getCipherEmail(customerId: $customerId, emailId: $emailId, trackId: $trackId)
}
`
export const GET_TPV_AUDIT_LIST = gql`
  query GetTpvAuditListBySystemAdmin(
  $tpvId: String!
    $perPage: Float
    $orderBy: String
    $page: Float
) {
  getTpvAuditListBySystemAdmin(tpvId: $tpvId, PerPage: $perPage, orderBy: $orderBy, page: $page) {
      recordList {
      operation
      role
      timeChanged
      userEmail
      userName
    }
    totalCount
  }
}
`

export const GET_TPVREPORTS_AUDIT = gql`
  query GetTpvAuditBySystemAdmin($email: String!, $timeChanged: String!, $tpvId: String!) {
  getTpvAuditBySystemAdmin(email: $email, timeChanged: $timeChanged, tpvId: $tpvId) {
      changes {
      fieldName
      newValue
      oldValue
    }
  }
}
`

export const GET_PRODUCT_AUDIT_LIST = gql`
  query GetProductAuditList($perPage: Float, $orderBy: String, $page: Float, $productId: String) {
  getProductAuditList(PerPage: $perPage, orderBy: $orderBy, page: $page, productId: $productId) {
      recordList {
      userName
      userEmail
      updatedBy
      timeChanged
      sectionId
      section
      role
      operation
    }
    totalCount
  }
}
`

export const GET_PRODUCT_AUDIT_DATA = gql`
  query GetProductAuditDataByProductId($productId: String!, $timeChanged: String!) {
  getProductAuditDataByProductId(productId: $productId, timeChanged: $timeChanged) {
      changes {
      fieldName
      newValue
      oldValue
    }
  }
}
`
export const GET_SCRIPT_AUDIT_DATA = gql`
  query GetScriptAuditDataByScriptId(
  $section: String!
    $sectionId: String!
    $timeChanged: String!
) {
  getScriptAuditDataByScriptId(
    section: $section
      sectionId: $sectionId
      timeChanged: $timeChanged
  ) {
      changes {
      fieldName
      newValue
      oldValue
    }
  }
}
`

export const GET_SCRIPT_AUDIT_LIST = gql`
  query GetScriptAuditList($scriptId: String!, $orderBy: String, $perPage: Float, $page: Float) {
  getScriptAuditList(scriptId: $scriptId, orderBy: $orderBy, PerPage: $perPage, page: $page) {
      recordList {
      operation
      role
      section
      sectionId
      timeChanged
      updatedBy
      userEmail
      userName
    }
    totalCount
  }
}
`

export const GET_SALES_CHANNEL_AUDIT_LIST = gql`
  query GetSalesChannelAuditList(
  $salesChannelId: String!
    $perPage: Float
    $orderBy: String
    $page: Float
) {
  getSalesChannelAuditList(
    salesChannelId: $salesChannelId
      PerPage: $perPage
      orderBy: $orderBy
      page: $page
  ) {
      recordList {
      role
      section
      sectionId
      timeChanged
      updatedBy
    }
    totalCount
  }
}
`

export const GET_SALES_CHANNEL_AUDIT_DATA = gql`
  query GetSalesChannelAuditDataBySalesChannelId(
  $section: String!
    $sectionId: String!
    $timeChanged: String!
) {
  getSalesChannelAuditDataBySalesChannelId(
    section: $section
      sectionId: $sectionId
      timeChanged: $timeChanged
  ) {
    action
      changes {
      newValue
      fieldName
      oldValue
    }
  }
}
`

export const UPDATE_SALES_CHANNEL_STATUS = gql`
  mutation UpdateSalesChannelStatus($id: String!, $isActive: Boolean!) {
  updateSalesChannelStatus(id: $id, isActive: $isActive)
}
`
export const UPDATE_USER_STATUS = gql`
  mutation UpdateUserStatus($isDisabled: Boolean!, $userId: String!) {
  updateUserStatus(isDisabled: $isDisabled, userId: $userId)
}
`
export const GET_SALESCHANNEL_AGENT_AUDIT_LIST = gql`
  query GetAgentAuditList($agentId: String!, $perPage: Float, $orderBy: String, $page: Float) {
  getAgentAuditList(agentId: $agentId, PerPage: $perPage, orderBy: $orderBy, page: $page) {
      recordList {
      operation
      role
      section
      sectionId
      timeChanged
      updatedBy
      userEmail
      userName
    }
    totalCount
  }
}
`

export const GET_SALESCHANNEL_AGENT_AUDIT_DATA = gql`
  query GetAgentAuditDataByAgentId($sectionId: String!, $timeChanged: String!) {
  getAgentAuditDataByAgentId(sectionId: $sectionId, timeChanged: $timeChanged) {
      changes {
      newValue
      fieldName
      oldValue
    }
  }
}
`
export const GET_OUTBOUND_CUSTOMER_LIST = gql`
  query GetOutBoundAgentCustomers($perPage: Float, $orderBy: String, $page: Float) {
  getOutBoundAgentCustomers(PerPage: $perPage, orderBy: $orderBy, page: $page) {
      customerList {
      DailInNumber
      customerId
      customerName
      pincode
      outBoundMessage
      tpvId
      clientName
      language
    }
    totalCount
  }
}
`

export const CHECK_OUTBOUND_CUSTOMER_STATUS = gql`
  query Query($tpvId: String!) {
  liveAgentPickCustomer(tpvId: $tpvId)
}
`

export const CHECK_OUTBOUND_CUSTOMER_CALL_STATUS = gql`
  query Query($answered: Boolean!, $tpvId: String!) {
  liveAgentCustomerCallStatus(Answered: $answered, tpvId: $tpvId)
}
`
export const LIVEAGENT_LEAVE_CALL = gql`
  mutation LiveAgentLeaveCall(
  $tpvId: String!
    $disposition: String
    $tpvStatus: String
    $isCustomerFlagged: Boolean
) {
  liveAgentLeaveCall(
    tpvId: $tpvId
      disposition: $disposition
      tpvStatus: $tpvStatus
      isCustomerFlagged: $isCustomerFlagged
  )
}
`

export const GET_CUSTOMER_PRODUCT_INFO_FOR_GAS = gql`
  query GetCustomerProductInfoForGas($filterInputs: ProductFilterInputs!, $productId: String!) {
  getCustomerProductInfoForGas(filterInputs: $filterInputs, productId: $productId) {
    commodity
    gContractType
    gUtility
    gUanValidation
    gRegexValidation
    gRegexValidationMessage
    gterm
    id
    name
    grate
    gserviceFee
    gearlyTerminationFee
    gcode
    brandType
    grateMaximum
    grateMinimum
    gtermMaximum
    gtermMinimum
    isDynamicProduct
    gMeterRegexValidation
    gMeterRegexValidationMessage
  }
}
`

export const CREATE_AGENT_LEADER = gql`
  mutation CreateAgentLeader($leaderInput: [AgentLeaderInput!]!, $salesChannelId: String!) {
  createAgentLeader(leaderInput: $leaderInput, salesChannelId: $salesChannelId)
}
`
export const GET_AGENT_LEADER_LIST = gql`
  query GetAgentLeaderList($page: Float!, $perPage: Float!, $salesChannelId: String!) {
  getAgentLeaderList(page: $page, perPage: $perPage, salesChannelId: $salesChannelId) {
    totalCount
      agentLeaders {
      leaderCode
      id
      leaderName
      leaderStatus
    }
  }
}
`
export const UPDATE_AGENT_LEADER = gql`
  mutation UpdateAgentLeader($updateAgentLeaderInputs: UpdateAgentLeaderInputs!) {
  updateAgentLeader(updateAgentLeaderInputs: $updateAgentLeaderInputs)
}
`
export const DELETE_AGENT_LEADER = gql`
  mutation DeleteAgentLeader($agentLeaderId: String!) {
  deleteAgentLeader(agentLeaderId: $agentLeaderId)
}
`

export const GET_AGENT_LEADER_LIST_FOR_AGENT = gql`
  query GetAgentLeaderListForAgent($salesChannelId: String!) {
  getAgentLeaderListForAgent(salesChannelId: $salesChannelId) {
    leaderCode
    leaderName
    id
  }
}
`
export const GET_AGENT_LEADER_INFO_FOR_EDIT_AGENT = gql`
  query GetAgentLeaderInfoForAgent($memberId: String!) {
  getAgentLeaderInfoForAgent(memberId: $memberId) {
    leaderCode
  }
}
`
export const CHECK_EXISTING_CUSTOMERR_FOR_SYMMETRY = gql`
  query CheckExistingSymmetryCustomer($customerInputs: CustomerInputs!) {
  checkExistingSymmetryCustomer(customerInputs: $customerInputs) {
    isExistingCustomer
  }
}
`
//test
export const CHECK_EXISTING_CUSTOMERR_FOR_PTM = gql`
  query CheckExistingPTMCustomer($customerUan: String!, $productId: String!) {
  checkExistingPTMCustomer(customerUan: $customerUan, productId: $productId)
}
`

export const GET_ALL_CUSTOMERS_BY_SYSTEM_ADMIN = gql`
  query GetAllCustomersBySystemAdmin($customerListInput: CustomerListInput) {
  getAllCustomersBySystemAdmin(customerListInput: $customerListInput) {
    totalCount
      customers {
      primaryPhoneNumber
      mobileNumber
      appInstalledStatus
      noOfMessageRetries
      isOpted
      smsOptedTime
    }
  }
}
`
export const CREATE_BULK_PRODUCTS = gql`
  mutation CreateBulkProducts($createProductInput: [CreateProductInput!]!) {
  createBulkProducts(createProductInput: $createProductInput) {
    id
  }
}
`
export const GET_UTILITIES_BY_ZIPCODE = gql`
  query GetUtilitiesByZipCode($zipCode: String!) {
  getUtilitiesByZipCode(zipCode: $zipCode) {
    id
    name
    utilityName
  }
}
`
export const GET_CLIENT_ALLOWED_COMPONENTS = gql`
  query {
  getClientAllowedComponents
}
`
export const GET_CUSTOMER_REPORT = gql`
  query GetCustomerReportByAgent($input: GetCustomerReportInput!) {
  getCustomerReportByAgent(input: $input) {
    totalCount
      customers {
      firstName
      lastName
      uniqueId
      confirmationNumber
      emailId
      tpvStatus
      agentFirstName
      agentLastName
      agentEmailId
      disposition
      qcStatus
      customerMobileNumber
    }
  }
}
`
export const GETALERTSETUP = gql`
  query GetAlertSetting {
    getAlertSetting {
    id
    enrollmentsByAgentInMinutes
    maximumEnrollmentOfAgentInADay
    minDistanceToCustomer
    minDistanceToServiceAddress
    noOfDaysMailRepeated
    noOfDaysPhoneRepeated
  }
}
`

export const CREATEALERTSETUP = gql`
  mutation CreateAlertSetting($createAlertSettingInput: CreateAlertSettingInput!) {
  createAlertSetting(createAlertSettingInput: $createAlertSettingInput) {
    enrollmentsByAgentInMinutes
    maximumEnrollmentOfAgentInADay
    minDistanceToServiceAddress
    minDistanceToCustomer
    noOfDaysMailRepeated
    noOfDaysPhoneRepeated
  }
}
`

export const UPDATEALERTSETUP = gql`
  mutation UpdateAlertSetting($updateAlertSettingInput: UpdateAlertSettingInput!) {
  updateAlertSetting(updateAlertSettingInput: $updateAlertSettingInput)
}
`
export const GET_AGENT_PRODUCT_AND_FILTER = gql`
  query GetAgentProductsAndFilter($input: AgentProductAndFiltersInput!) {
  getAgentProductsAndFilter(input: $input) {
      products {
      id
      name
        commodity {
        id
        name
      }
      term
      rate
      serviceFee
      gserviceFee
      gcode
      gterm
      grate
      gearlyTerminationFee
      earlyTerminationFee
        productScripts {
        id
        scriptId
      }
        gutility {
        uanValidation
        regexValidation
        regexValidationMessage
        meterRegexValidation
        meterRegexValidationMessage
        notesMetadata
        __typename
      }
        utility {
        uanValidation
        regexValidation
        regexValidationMessage
        meterRegexValidation
        meterRegexValidationMessage
        notesMetadata
        __typename
      }
      ecode
      startDate
      endDate
      isDynamicProduct
      grateMaximum
      grateMinimum
      gtermMaximum
      gtermMinimum
      rateMaximum
      rateMinimum
      termMaximum
      termMinimum
    }
      productFilters {
        brands {
        id
        name
      }
        commodities {
        id
        name
      }
        contractTypes {
        id
        name
      }
        customerTypes {
        id
        name
      }
        utilities {
        id
        name
        utilityShortName
        utilityName
      }
        solarProducts {
        id
        name
      }
        states {
        name
      }
        billingMethods {
        name
      }
    }
      gasProducts {
      id
      name
        commodity {
        id
        name
      }
      term
      rate
      serviceFee
      gserviceFee
      gcode
      gterm
      grate
      gearlyTerminationFee
      earlyTerminationFee
        gutility {
        uanValidation
        regexValidation
        regexValidationMessage
        meterRegexValidation
        meterRegexValidationMessage
        __typename
      }
        utility {
        uanValidation
        regexValidation
        regexValidationMessage
        meterRegexValidation
        meterRegexValidationMessage
        __typename
      }
      ecode
      startDate
      endDate
      isDynamicProduct
      grateMaximum
      grateMinimum
      gtermMaximum
      gtermMinimum
      rateMaximum
      rateMinimum
      termMaximum
      termMinimum
    }
      gasProductFilters {
        brands {
        id
        name
      }
        commodities {
        id
        name
      }
        contractTypes {
        id
        name
      }
        customerTypes {
        id
        name
      }
        utilities {
        id
        name
        utilityName
        utilityShortName
      }
        solarProducts {
        id
        name
      }
        states {
        name
      }
        billingMethods {
        name
      }
    }
  }
}
`
export const GET_AGENT_PRODUCT_AND_FILTER_SOLAR = gql`
  query GetAgentProductsAndFilter($input: AgentProductAndFiltersInput!) {
  getAgentProductsAndFilter(input: $input) {
      products {
      id
      name
        commodity {
        id
        name
      }
      term
      rate
      serviceFee
      gserviceFee
      gcode
      gterms
      grate
      gearlyTerminationFee
      earlyTerminationFee
        gutility {
        uanValidation
        regexValidation
        regexValidationMessage
        meterRegexValidation
        meterRegexValidationMessage
        __typename
      }
        utility {
        uanValidation
        regexValidation
        regexValidationMessage
        meterRegexValidation
        meterRegexValidationMessage

        __typename
      }
      ecode
      startDate
      endDate
      isDynamicProduct
      grateMaximum
      grateMinimum
      gtermMaximum
      gtermMinimum
      rateMaximum
      rateMinimum
      termMaximum
      termMinimum
    }
      productFilters {
        customerTypes {
        id
        name
      }
        utilities {
        id
        name
        utilityShortName
        utilityName
      }
        solarProducts {
        id
        name
      }
        states {
        name
      }
        billingMethods {
        name
      }
    }
      gasProducts {
      id
      name
        commodity {
        id
        name
      }
      term
      rate
      serviceFee
      gserviceFee
      gcode
      gterm
      grate
      gearlyTerminationFee
      earlyTerminationFee
        gutility {
        uanValidation
        regexValidation
        regexValidationMessage
        meterRegexValidation
        meterRegexValidationMessage
        __typename
      }
        utility {
        uanValidation
        regexValidation
        regexValidationMessage
        meterRegexValidation
        meterRegexValidationMessage
        __typename
      }
      ecode
      startDate
      endDate
      isDynamicProduct
      grateMaximum
      grateMinimum
      gtermMaximum
      gtermMinimum
      rateMaximum
      rateMinimum
      termMaximum
      termMinimum
    }
      gasProductFilters {
        customerTypes {
        id
        name
      }
        utilities {
        id
        name
        utilityName
        utilityShortName
      }
        solarProducts {
        id
        name
      }
        states {
        name
      }
        billingMethods {
        name
      }
    }
  }
}
`

export const GET_LINE_TYPE_INTELLIGENCE = gql`
  query getLineTypeIntelligence($phoneNumber: String!) {
  getLineTypeIntelligence(phoneNumber: $phoneNumber) {
    carrierName
    type
    phoneNumber
    countryCode
    mobileCountryCode
    mobileNetworkCode
    errorCode
  }
}
`

export const CREATE_OR_UPDATE_SMART_DOCUMENT = gql`
  mutation createOrUpdateSmartDocument($id: String, $data: UpsertSmartDocDetailsInput!) {
  createOrUpdateSmartDocument(id: $id, data: $data) {
    smartDocId
  }
}
`
export const GET_TPV_LIST_WITH_MISSING_CONTRACTS = gql`
query GetTpvListWithMissingContracts($clientId: [String!]){
  getTpvListWithMissingContracts(clientId: $clientId)
}
`

export const RETRIEVE_CONTRACTS = gql`
mutation retrieveContract($clientId: [String!]) {
  retrieveContract(clientId: $clientId)
}
`
export const RETRIEVE_MISSING_CONTRACTS = gql`
mutation RegenerateTPV($tpvId: String!) {
  regenerateTpvContract(tpvId: $tpvId)
}
`
